/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a number and see it spelled out in English words — useful for writing cheques, invoices, contracts and forms.`)
};

const es_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe un número y mira cómo se deletrea en palabras inglesas — útil para escribir cheques, facturas, contratos y formularios.`)
};

const de_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Zahl ein und sehen Sie sie in englischen Worten ausgeschrieben — nützlich zum Ausfüllen von Schecks, Rechnungen, Verträgen und Formularen.`)
};

const nl_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ een getal en zie het uitgeschreven in Engelse woorden — handig voor het schrijven van cheques, facturen, contracten en formulieren.`)
};

const fr_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez un nombre et voyez son écriture en toutes lettres — utile pour écrire des chèques, factures, contrats et formulaires.`)
};

const it_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita un numero e vedi come si scrive in parole inglesi — utile per scrivere assegni, fatture, contratti e moduli.`)
};

const pt_br2_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um número e veja como ele é escrito em palavras em português — útil para escrever cheques, notas fiscais, contratos e formulários.`)
};

const pt_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um número e veja-o soletrado em palavras inglesas — útil para escrever cheques, faturas, contratos e formulários.`)
};

const ja_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字を入力して、英語の単語で綴られたテキストを表示してください。小切手、請求書、契約書、フォームの作成に便利です。`)
};

const zh_nw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入一个数字，即可看到它用英文单词拼写出来——适用于填写支票、发票、合同和表格。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_intro", locale)
	if (locale === "en") return en_nw_intro(inputs)
	if (locale === "es") return es_nw_intro(inputs)
	if (locale === "de") return de_nw_intro(inputs)
	if (locale === "nl") return nl_nw_intro(inputs)
	if (locale === "fr") return fr_nw_intro(inputs)
	if (locale === "it") return it_nw_intro(inputs)
	if (locale === "pt-BR") return pt_br2_nw_intro(inputs)
	if (locale === "pt") return pt_nw_intro(inputs)
	if (locale === "ja") return ja_nw_intro(inputs)
	return zh_nw_intro(inputs)
};